import { useEffect, useState } from 'react';
import { loggedIn } from "../components/common";
// import { NewSiteWizard } from "../components/new-site-wizard";
import { subStacksBreadcrumbs } from "../components/common";

import { useNavigate } from 'react-router-dom';
import { NewStackForm } from "../components/new-stack-form";

import {
  BreadcrumbGroup,
} from '@cloudscape-design/components';

import '../css/base.scss';

const Breadcrumbs = ({navigate, item}) => (
  <BreadcrumbGroup
    onFollow={event => {
      event.preventDefault();
      navigate(event.detail.href);
    }}
    items={subStacksBreadcrumbs(item)}
    expandAriaLabel="Show path"
    ariaLabel="Breadcrumbs" />
)

export default function NewStack({ state }) {
  const navigate = useNavigate();
  if (!loggedIn()) {
    return null;
  }
  useEffect(() => {
    state.activeHref.setHref("/stacks");
    state.breadCrumbs.setCrumbs(
      <Breadcrumbs navigate={navigate} item="Create Stack" />
    )
    state.maxContentWidth.setWidth(Number.MAX_VALUE);
    state.contentType.setType("default");
  }, []);
  return (
      <NewStackForm resource="Stack" url="stacks" flashbar={state.flashBar}/>
  );
}
